// @flow

import { BaseService } from '@performant-software/shared-components';
import { createService } from '@udcsl/shared';
import ProjectAward from '../transforms/ProjectAward';

const ProjectAwardsService: typeof BaseService = createService({ path: '/api/project_awards', transform: ProjectAward });
export default ProjectAwardsService;
